import { render, staticRenderFns } from "./AllotRule.vue?vue&type=template&id=4ae03837&"
import script from "./AllotRule.vue?vue&type=script&lang=js&"
export * from "./AllotRule.vue?vue&type=script&lang=js&"
import style0 from "./AllotRule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports